import { Warehouse } from "@models/Address";

const warehouseLabels: Record<Warehouse, string> = {
  [Warehouse.Champion]: "Champion",
  [Warehouse.Vernon]: "Vernon",
  [Warehouse.ShipStation]: "ShipStation",
  [Warehouse.ClarkAndRiggsSAB]: "Clark & Riggs - SAB",
  [Warehouse.ClarkAndRiggsSRS]: "Clark & Riggs - SRS",
  [Warehouse.ClarkAndRiggsCouponsAndRebates]:
    "Clark & Riggs - Coupons & Rebates",
};
export default function warehouseLabel(warehouseId: Warehouse | string) {
  return warehouseLabels[warehouseId] ?? warehouseId;
}
